/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Samplenote2Inputs */

const ja_playdata_eventreport_samplenote2 = /** @type {(inputs: Playdata_Eventreport_Samplenote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプルレポートを公開しています。全10ページ以上の詳細レポートをご覧になりたい方は以下からご確認ください。`)
};

const en_playdata_eventreport_samplenote2 = /** @type {(inputs: Playdata_Eventreport_Samplenote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sample report is available. The full report runs to more than ten pages.`)
};

/**
* | output |
* | --- |
* | "A sample report is available. The full report runs to more than ten pages." |
*
* @param {Playdata_Eventreport_Samplenote2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_samplenote2 = /** @type {((inputs?: Playdata_Eventreport_Samplenote2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Samplenote2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_samplenote2(inputs)
	return en_playdata_eventreport_samplenote2(inputs)
});
export { playdata_eventreport_samplenote2 as "playdata_eventReport_sampleNote" }